export const catreload = {
  name: 'cat-reload',

  bind: (el) => {

    el.addEventListener('change', (e) =>{
      const param = e.target.options[e.target.options.selectedIndex].value;
      const currentUrl = location.protocol + '//' + location.host + location.pathname;
      const name = e.target.getAttribute('name');
      const newUrl = `${currentUrl}?${name}=${param}`;
      window.location.href = newUrl;
    });
  }
};
